import { Google as GoogleIcon, Microsoft as MicrosoftIcon } from '@mui/icons-material';
import { Button, IconButton, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { getProviderURl } from '../../apis/authentication';
import { GlobalVariables, config } from '../../config/configurations';
import { cleanMeetingFromLocalStorage } from '../../helpers/localStorage';
import { SocialLoginProps } from '../../interfaces/ILogin';
import {
  ForcedProvider,
  clearForcedSsoAttempt,
  resolveLoginProvider,
  shouldStartForcedSso,
} from './sso.helpers';

const globalVar = GlobalVariables.getInstance();

const SocialAuth: React.FC<SocialLoginProps> = (props: SocialLoginProps) => {
  const [is_connected, setIsConnected] = React.useState(false);

  const getProviderURlInAnyCase = async (provider: string) => {
    if (props.mode === 'addon') {
      const base_url = `${config.REACT_APP_URL_BACKEND_API}/${config.REACT_APP_API_VERSION}/authentication/oauth2`;
      props.callback(
        provider,
        `${base_url}/authorize?mode=${globalVar.getIntegrationMode()}`,
        `${base_url}/grant?mode=${globalVar.getIntegrationMode()}`,
        setIsConnected,
      );
    } else {
      getProviderURl(provider).then((res) => {
        cleanMeetingFromLocalStorage();
        window.location.href = res.data.redirect;
      });
    }
  };

  useEffect(() => {
    if (is_connected) {
      window.location.href = '/index.html#';
    }
  }, [is_connected]);

  useEffect(() => {
    const provider = resolveLoginProvider(window.location.search, props.enforcedProvider);
    if (!provider || !shouldStartForcedSso(provider)) {
      return;
    }
    void getProviderURlInAnyCase(provider).catch(() => {
      clearForcedSsoAttempt();
    });
  }, []);

  const offers = (provider: ForcedProvider) =>
    !props.enforcedProvider || props.enforcedProvider === provider;

  return (
    <Stack direction={props.direction} spacing={2}>
      {offers('google') && (
        <>
          {props.direction === 'row' && (
            <IconButton
              onClick={() => {
                getProviderURlInAnyCase('google');
              }}
              sx={styles.iconButton}
            >
              <GoogleIcon />
            </IconButton>
          )}
          {props.direction === 'column' && (
            <Button
              fullWidth
              size="large"
              variant="outlined"
              onClick={() => {
                getProviderURlInAnyCase('google');
              }}
              sx={styles.button}
              startIcon={<GoogleIcon />}
            >
              Google
            </Button>
          )}
        </>
      )}
      {offers('microsoft') && (
        <>
          {props.direction === 'row' && (
            <IconButton
              onClick={() => {
                getProviderURlInAnyCase('microsoft');
              }}
              sx={styles.iconButton}
            >
              <MicrosoftIcon />
            </IconButton>
          )}
          {props.direction === 'column' && (
            <Button
              fullWidth
              size="large"
              variant="outlined"
              onClick={() => {
                getProviderURlInAnyCase('microsoft');
              }}
              sx={styles.button}
              startIcon={<MicrosoftIcon />}
            >
              Microsoft
            </Button>
          )}
        </>
      )}
    </Stack>
  );
};

const styles = {
  iconButton: {
    border: '2px solid #ccc',
    borderRadius: '5px',
    padding: '0.5675rem',
    flex: 1,
    '&:hover': {
      border: '2px solid #ccc',
    },
  },
  button: {
    border: '2px solid #ccc',
    borderRadius: '5px',
    padding: '0.5675rem',
    flex: 1,
    color: 'text.secondary',
    '&:hover': {
      border: '2px solid #ccc',
    },
  },
} as const;

export default SocialAuth;
